import React from 'react';
import SingleBannerButton from './SingleBannerButton';
import CarouselBannerButton from './CarouselBannerButton';
import CategoryButton from './CategoryButton';
import CategoryCollectionListButton from './CategoryCollectionListButton';
import CustomCollectionListButton from './CustomCollectionListButton';
import OfferDisplayButton from './OfferDisplayButton';
import CrossGray from '../../../../Assets/StorefrontIcons/CrossGray.svg';
import { useDispatch } from 'react-redux';
import { setSectionFormType, setSectionType } from '../../../../Features/storefrontSlice';

function StoreSectionOptions() {
    const dispatch = useDispatch();

    function handleClose() {
        dispatch(setSectionType(null));
        dispatch(setSectionFormType(null));
    }

    return (
        <div className='ml-0 w-[250px] h-full bg-[#FFFFFF] border-r border-[#EAEAEA] flex flex-col gap-1'>
            <div className="flex items-center justify-between">
                <p className='font-semibold text-[20px] leading-6 text-[#121212] pl-3'>Add Sections</p>

                <div className="size-11 p-[10px] flex items-center justify-center">
                    <button onClick={handleClose} className='size-6 flex items-center justify-center outline-none'>
                        <img src={CrossGray} alt="" />
                    </button>
                </div>
            </div>

            <div className="h-[calc(100%-44px)] flex flex-col gap-3 px-3 overflow-y-scroll no-scrollbar pt-1 pb-3">
                <SingleBannerButton />

                <CarouselBannerButton />

                <CategoryButton />

                <CategoryCollectionListButton />

                <CustomCollectionListButton />

                <OfferDisplayButton />
            </div>
        </div>
    );
}

export default StoreSectionOptions;
